<template>
  <v-container v-if="offerData.id" :loading="loading">
    <v-tabs v-model="tab">
      <v-tab>Übersicht</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <order-overview
          :overview="overview"
          :offer-data="offerData"
          :editable="true"
        />
        <v-container fluid>
          <v-row>
            <v-col>
              <v-card width="100%">
                <v-card-text>
                  <v-row>
                    <v-col cols="6" class="d-flex">
                      <inertia-link
                        v-if="$page.props.user.permissions.offer.nwt_view || $page.props.user.permissions.offer.man_edit_view"
                        class="mr-3"
                        :href="route('offerData.edit.manually', offerData.id)"
                        method="get"
                      >
                        <v-btn color="secondary">
                          manuelles Editieren
                        </v-btn>
                      </inertia-link>
                      <inertia-link
                        v-if="$page.props.user.permissions.offer.nwt_view || $page.props.user.permissions.offer.man_edit_view"
                        class=""
                        :href="route('offerData.edit', offerData.id)"
                        method="get"
                      >
                        <v-btn color="primary">
                          Editieren
                        </v-btn>
                      </inertia-link>
                    </v-col>
                    <v-col cols="6" class="d-flex justify-end ">
                      <v-btn class="mr-3" color="secondary" @click="dialog = true">
                        <v-icon> mdi-publish </v-icon>
                        freigeben
                      </v-btn>
                      <order-export :orderid="offerData.id" :termid="parseInt(offerData.term_id)" />
                    </v-col>
                    <v-col cols="12">
                      <v-divider class="mb-3" />
                    </v-col>
                    <v-col cols="6">
                      <v-select v-model="editTerm" :items="terms" label="Laufzeit" />
                    </v-col>
                    <v-col cols="6">
                      <v-select v-model="editPug" :items="pugs" label="Telekom Pug" />
                    </v-col>
                    <v-col cols="12" class="d-flex justify-end">
                      <v-btn color="primary" @click="updateRuntimePug">
                        Speichern
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Freigabe-Einstellungen</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select v-model="term" :items="terms" label="Laufzeit" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn left @click="dialog = false">
            zurück
          </v-btn>
          <v-spacer />
          <v-btn color="primary" @click="publishItem">
            freigeben
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : `Preisinformation ${this.offerData.id}`,
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      offerData: {
         type: Object,
         required: true,
      },
      overview: {
         type: Object,
         required: true,
      },
   },
   data: function () {
      return {
         dialog: false,
         loading: true,
         tab: 0,
         editTerm: parseInt(this.offerData.term_id),
         editPug: parseInt(this.offerData.preliminary_pug),
         pugs: [
            { text: 'PUG 1', value: 1 },
            { text: 'PUG 2', value: 2 },
            { text: 'PUG 3', value: 3 },
         ],
         term: 3,
         terms: [
            { text: '36 Monate', value: 2 },
            { text: '60 Monate', value: 3 },
         ],
      }
   },

   methods: {
      publishItem () {
         this.$inertia.post(
            this.route('offer.store', {
               offerData: this.offerData.id,
               term: this.term,
            })
         )
      },

      updateRuntimePug () {
         if (parseInt(this.editTerm) !== parseInt(this.offerData.term) || parseInt(this.editPug) !== this.offerData.preliminary_pug) {
            this.$inertia.post(
               this.route('offerData.updatePreliminaryPugAndTerm', this.offerData.id),
               {
                  term: this.editTerm,
                  pug: this.editPug,

               }
            )
         }
      }

   }
}
</script>
